import React from 'react';

import * as Alerts from './StyledComponent';
import * as Styled from './StyledComponentAlert';

export const ComponentAlert = props => (
    <Styled.ComponentAlert className={props.className} type={props.type}>
        {props.icons && (
            <Alerts.Icons>
                <span className={`icon fa-fw ${props.icons}`} aria-hidden="true" />
            </Alerts.Icons>
        )}

        {props.image && (
            <Alerts.Image>
                <img src={props.image.src} alt={props.image.alt} />
            </Alerts.Image>
        )}

        {props.title && <Alerts.Title>{props.title}</Alerts.Title>}
        {props.descr && <Alerts.Descr>{props.descr}</Alerts.Descr>}

        {props.buttn && !props.buttn.length && (
            <Alerts.Buttn
                to={props.buttn.href || props.buttn.to}
                type={props.buttn.type || props.type}
            >
                <span className="text">{props.buttn.text}</span>
            </Alerts.Buttn>
        )}
        {props.buttn &&
            props.buttn.length &&
            props.buttn.map(b => (
                <Alerts.Buttn
                    key={`cab-${b.href || b.to}`}
                    to={b.href || b.to}
                    type={b.type || props.type}
                >
                    <span className="text">{b.text}</span>
                </Alerts.Buttn>
            ))}

        {props.children}
    </Styled.ComponentAlert>
);
export const Alert = ComponentAlert;
export default ComponentAlert;
